module.exports = __webpack_public_path__ + "static/media/logo-ssp.73f7b6cb.jpg";